import { execute, FilterConditions, INSERT, SELECT, UPDATE } from "@/utils/database_module";
import products from "./products";
import { OrderStatus, SourcingRequest, User } from "@/utils/types";

const sourcing = {
  insert: async (data: SourcingRequest) => {
    const sourcingData = {...data, products: JSON.stringify(data.products)};
    return await INSERT("sourcingRequests", sourcingData);
  },
  update: async (id : number , value : PartialSourcingRequest) => {
    let sourcingData = value 
    if(value.products){
      
      sourcingData = {...value, products: JSON.stringify(value.products)};
    }
    return await UPDATE("sourcingRequests", sourcingData , [{column : "id" , operator : "=" , value : id}])
  },
  

  getAll: async (status? : number , user_id? : number , startDate? : string , endDate? : string ,) => {
  const condition =[{ column : "is_deleted" , operator : "=" , value : 0}] as any;
    if(status && status!=0 ) condition.push({ column : "status" , operator : "=" , value : status ?? ""})
    if(user_id  ) condition.push({ column : "user_id" , operator : "=" , value : user_id ?? ""})
    if(startDate) condition.push({ column : "date" , operator : ">=" , value : startDate ?? ""})
    if(endDate) condition.push({ column : "date" , operator : "<=" , value : endDate ?? ""})
      const sourcingRequests = (await SELECT("sourcingRequests", {
      conditions:condition,
      order: "date DESC",
    })) as SourcingRequest[];

    const users = sourcingRequests && sourcingRequests?.length != 0 ? await execute(`SELECT * FROM users WHERE id IN (${sourcingRequests.map((r) => r.user_id).join(", ")})`) as User[] : [];
    const statuses = await SELECT("order_status" , {}) as OrderStatus[];
   
    for (const sourcing of sourcingRequests) {
        const products = JSON.parse(`${sourcing.products}`);
        sourcing.products = products;
        sourcing.user = users.find((user) => user.id == sourcing.user_id); 
        sourcing.status = statuses.find((status) => status.id == sourcing.status);
    }
    
    return sourcingRequests
  },

  delete : async (id : number) => {
    return await UPDATE("sourcingRequests" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
},
};

export default sourcing;


type PartialSourcingRequest = {
  status?: OrderStatus | number;
  products?:string| { name: string; img: string; comment: string , category: string , finalPrice?: number , adminImg?: string , video?: string , adminComment?: string}[];

};